import React, { useContext, useEffect, useState } from 'react';
import { fetchMessageTemplatesByType } from '../../../Service/restapi/messageService';
import { LoadingAnimation } from '../../../Service/ResourceAdapter';
import MessageTemplateListItem from './MessageTemplateListItem';

export default function () {
  const [messageTemplates, setMessageTemplates] = useState(undefined);

  useEffect(() => {
    fetchMessageTemplatesByType('CUSTOM').then((resp) => {
      if (resp.ok) {
        resp.json().then(setMessageTemplates);
      }
    });
  }, []);

  if (!messageTemplates) {
    return <LoadingAnimation />;
  }
  console.log({ messageTemplates });
  return (
    <div>
      {messageTemplates.map((messageTemplate, index) => (
        <MessageTemplateListItem key={index} messageTemplate={messageTemplate} />
      ))}
    </div>
  );
}
